/* userInterface */
import request from '@/utils/request.js'

// simBooking
export const BookingReq = data => {
  return request({
    method: 'POST',
    url: '/customerapi/V1/booking',
    data,
  })
}

// Advbooking
export const AdvbookingReq = data => {
  return request({
    method: 'POST',
    url: '/customerapi/V1/advbooking',
    data,
  })
}

// Bookingslots
export const BookingslotsReq = params => {
  return request({
    method: 'GET',
    url: 'customerapi/V1/bookingslots',
    params,
  })
}

// Get payment intent for booking
export const BookingPaymentReq = data => {
  return request({
    method: 'POST',
    url: '/customerapi/V1/bookingdeposit/intent',
    data,
  })
}

// Get payment intent for booking without login
export const BookingPaymentWithoutReq = data => {
  return request({
    method: 'POST',
    url: '/customerapi/V1/bookingdeposit/guestintent',
    data,
  })
}

// Get payment setup intent for booking
export const BookingPaymentSetupReq = data => {
  return request({
    method: 'POST',
    url: '/customerapi/V1/bookingdeposit/setupintent',
    data,
  })
}

// Get payment setup intent for booking as guest
export const BookingPaymentSetupWithoutReq = data => {
  return request({
    method: 'POST',
    url: '/customerapi/V1/bookingdeposit/guestsetupintent',
    data,
  })
}


// information 

// List booking
export const GetBookingListReq = params => {
  return request({
    method: 'GET',
    url: 'customerapi/V1/booking',
    params,
  })
}

// Update one booking as a guest customer
export const UpdateBookingReq = ({id,data}) => {
  return request({
    method: 'POST',
    url: '/customerapi/V1/guest/booking/' + id,
    data,
  })
}

// Get Timestamp 
export const GetTimestampReq = () => {
  return request({
    method: 'GET',
    url: '/customerapi/V1/timestamp',
  })
}
